import { action, observable } from 'mobx';
import { SerializedData } from 'bernie-core';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';
import { RequestOptions } from 'bernie-graphql';
import { clientInfoHeader } from 'utility/header-utils';
import { FlightsSearchMetadata } from '__generated__/api';
import { BaseBexApiStore } from 'stores/bex-api-store';

export class FlightsSearchMetadataStore extends BaseBexApiStore {
  @observable public primary: string;
  @observable public secondary: string;

  public hydrate(data: SerializedData): void {
    super.hydrate(data);
    this.bexApiSource.clientConfigs.bexApiUrl = '/graphql';
  }

  @action
  public setMessages(messaging) {
    this.primary = messaging?.primary;
    this.secondary = messaging?.secondary;
  }

  public fetchResults(variables, options: RequestOptions): Promise<FlightsSearchMetadata.FlightsSearchMetadata> {
    const { appName, region } = this.bexApiSource.clientConfigs;

    this.bexApiSource.headers = clientInfoHeader(this.bexApiSource.headers, appName, region);
    const flightsSearchMetadataVariables = {
      context: variables.context,
      flightsSearchContext: variables.flightsSearchContext,
      journeyCriteria: {
        ...variables.journeyCriteria[0]
      }
    };

    return this.bexApiSource.operations
      .flightsSearchMetadata(flightsSearchMetadataVariables, options)
      .then(response => {
        const { flightsSearchMetadata } = response?.data ?? {};

        return flightsSearchMetadata;
      })
      .catch(error => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.WARN, 'SEARCH_METADATA_FETCH'), error);

        return null;
      });
  }
}

FlightsSearchMetadataStore.DEFAULTS = {};
